import { css, Theme } from '@emotion/react'

export const container = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  height: fit-content;
  padding: 14px;
  gap: 12px;
  border-radius: 17px;
  border: 1px solid ${theme.backgrounds.backgroundTwo};
  background: ${theme.backgrounds.backgroundFour};
  box-shadow: ${theme.boxShadows.small};
`

export const header = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const dndIcon = css`
  transform: rotate(90deg);
`

export const label = (theme: Theme) => css`
  font-weight: 400;
  color: ${theme.typographyColors.typographyThree};
  margin-bottom: 10px;
`

export const textareaAutosize = (theme: Theme) => css`
  box-sizing: border-box;
  width: 531px;
  min-width: 531px;
  max-width: 531px;
  color: ${theme.typographyColors.typographyFour};

  textarea {
    font-size: 16px;
    font-weight: 400;
    padding: 14px;
  }
`

export const textareaAutosizeActive = (theme: Theme) => css`
  color: ${theme.typographyColors.typographyThree};
`

export const actionButtons = css`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`
